import Vue from 'vue'

const errorText = (error) => `${error.status} - ${error.body.reason}`

export default {
  /* #####################################################################
  *
  *      Authentication
  *
  * #####################################################################
  */
  apiAuthLogin (payload) {
    return Vue.http.post(`api/oauth/login`, payload).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },

  apiAuthForgotPassword (payload) {
    return Vue.http.post(`api/oauth/forgot-password`, payload).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },

  apiAuthResetPassword (payload) {
    const {token, ...rest} = payload
    return Vue.http.post(`api/oauth/password-reset?request=${token}`, rest).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },

  /* #####################################################################
  *
  *      Invoices
  *
  * #####################################################################
  */
  getAllInvoices () {
    return Vue.http.get('api_v2/invoice').then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getAllClientInvoices (id) {
    return Vue.http.get(`api_v2/client/${id}/invoices`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getSingleInvoice (id) {
    return Vue.http.get(`api_v2/invoice/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  addInvoiceAdjustment (data) {
    return Vue.http.post(`api_v2/adjustment`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateInvoiceAdjustment (data) {
    return Vue.http.put(`api_v2/adjustment/${data.id}`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  deleteInvoiceAdjustment (id) {
    return Vue.http.delete(`api_v2/adjustment/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateSingleInvoice (update) {
    return Vue.http.put(`api_v2/invoice/${update.invoiceId}`, update).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  uploadSingleInvoiceFile (data) {
    return Vue.http.post(`api_v2/invoice/${data.id}/upload`, data.file).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  /* #####################################################################
  *
  *      Users
  *
  * #####################################################################
  */
  getAllUsers () {
    return Vue.http.get('api_v2/user').then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getSingleUser (id) {
    return Vue.http.get(`api_v2/user/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateSingleUser (data) {
    return Vue.http.put(`api_v2/user/${data.hash_id}`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  deleteSingleUser (id) {
    return Vue.http.delete(`api_v2/user/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  resetUserPassword (id) {
    return Vue.http.get(`api_v2/user/${id}/reset-password`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  addSingleUser (data) {
    return Vue.http.post(`api_v2/user`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  /* #####################################################################
  *
  *      Clients
  *
  * #####################################################################
  */
  getAllClients () {
    return Vue.http.get('api_v2/client').then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getSingleClient (id, params) {
    return Vue.http.get(`api_v2/client/${id}`, params).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateSingleClient (data) {
    return Vue.http.put(`api_v2/client/${data.hash_id}`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  addSingleClient (data) {
    return Vue.http.post(`api_v2/client`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  deleteSingleClient (id) {
    return Vue.http.delete(`api_v2/client/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  uploadSingleImage (data) {
    return Vue.http.post(`api_v2/client/${data.id}/logo`, data.file).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  deleteSingleImage (id) {
    return Vue.http.delete(`api_v2/client/${id}/logo`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  /* #####################################################################
  *
  *      Profile
  *
  * #####################################################################
  */
  getCurrentUser () {
    return Vue.http.get(`api_v2/user/current`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  /* #####################################################################
  *
  *      Campaigns
  *
  * #####################################################################
  */
  getAllCampaigns () {
    return Vue.http.get('api_v2/campaign').then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getClientCampaigns (id) {
    return Vue.http.get(`api_v2/client/${id}/campaigns`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  addSingleCampaign (campaign) {
    return Vue.http.post('api_v2/campaign', campaign).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getSingleCampaign (id) {
    return Vue.http.get(`api_v2/campaign/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateSingleCampaign (data) {
    return Vue.http.put(`api_v2/campaign/${data.id}`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  deleteSingleCampaign (id) {
    return Vue.http.delete(`api_v2/campaign/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  cloneSingleCampaign (id) {
    return Vue.http.post(`api_v2/campaign/${id}/clone`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  /* #####################################################################
  *
  *      Creatives
  *
  * #####################################################################
  */
  addSingleCreative (creative) {
    return Vue.http.post('api_v2/creative', creative).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getAllCreatives (id) {
    return Vue.http.get(`api_v2/campaign/${id}/creatives`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  deleteSingleCreative (id) {
    return Vue.http.delete(`api_v2/creative/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateSingleCreative (data) {
    return Vue.http.put(`api_v2/creative/${data.hash_id}`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  editSingleCreativeName (data) {
    return Vue.http.put(`api_v2/creative/${data.hash_id}`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getAllCreativeUnits (id, {pager, sorting, searchTerms}) {
    const sortingQuery = sorting && sorting.length > 0 ? `&sort=${JSON.stringify(sorting)}` : ''
    const searchTermsQuery = searchTerms ? `&search=${searchTerms}` : ''
    const queryString = `?page=${pager.page}&pageSize=${pager.pageSize}${sortingQuery}${searchTermsQuery}`
    return Vue.http.get(`api_v2/creative/${id}/units${queryString}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getCreativeUnit (id) {
    return Vue.http.get(`api_v2/creative/singleunit/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateSingleCreativeUnit (data) {
    return Vue.http.put(`api_v2/creative/singleunit/${data.id}`, [data.columns, ...data.unit]).then(response => {
      console.log(response.data)
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateAllCreativeUnits (data, {pager, sorting, searchTerms}) {
    const sortingQuery = sorting && sorting.length > 0 ? `&sort=${JSON.stringify(sorting)}` : ''
    const searchTermsQuery = searchTerms ? `&search=${searchTerms}` : ''
    const queryString = `?page=${pager.page}&pageSize=${pager.pageSize}${sortingQuery}${searchTermsQuery}`
    return Vue.http.put(`api_v2/creative/${data.id}/units${queryString}`, [data.columns, ...data.unit]).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateBulkCreativeUnits (data) {
    return Vue.http.post(`api_v2/creative/${data.id}/bulk`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  uploadCsvToCreative (data) {
    return Vue.http.post(`api_v2/creative/${data.id}/upload`, data.file).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  cloneSingleCreative (data) {
    return Vue.http.post(`api_v2/creative/${data.creativeId}/clone`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  reviewLInkHistory (creativeHashId) {
    return Vue.http.get(`api_v2/review/${creativeHashId}/history`).then(
      response => response.data,
      error => {
        throw errorText(error)
      })
  },
  /* #####################################################################
  *
  *      Assets
  *
  * #####################################################################
  */
  getAllAssets (id) {
    return Vue.http.get(`api_v2/creative/${id}/assets`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getAllImageAssets (id) {
    return Vue.http.get(`api_v2/creative/${id}/imageassets`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getAllVideoAssets (id) {
    return Vue.http.get(`api_v2/creative/${id}/videoassets`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  uploadAssetsToCreative (data) {
    return Vue.http.post(`api_v2/creative/${data.id}/assets`, data.file).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  copyAssetsToCreative (data) {
    return Vue.http.post(`api_v2/creative/${data.id}/copy-assets`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  deleteSingleAsset (data) {
    return Vue.http.delete(`api_v2/creative/${data.id}/assets/${data.fileName}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  /* #####################################################################
  *
  *      Links
  *
  * #####################################################################
  */
  getAllLinks ({type, page, pageSize, searchTerms}) {
    const queryString = `?type=${type}&page=${page}&pageSize=${pageSize}`
    const searchTermsQuery = searchTerms ? `&search=${searchTerms}` : ''

    return Vue.http.get(`api_v2/review${queryString}${searchTermsQuery}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  deleteSingleLink (id) {
    return Vue.http.delete(`api_v2/review/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  refreshSingleLink (id) {
    return Vue.http.get(`api_v2/review/${id}/refresh`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateSingleLink (data) {
    return Vue.http.put(`api_v2/review/${data.id}`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  validateClone (data) {
    return Vue.http.get(`api_v2/review/${data.id}/validate-clone`).then(({data}) => data, error => { throw errorText(error) })
  },
  /* #####################################################################
  *
  *      Tags
  *
  * #####################################################################
  */
  getAllTags () {
    return Vue.http.get(`api_v2/adtag`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getAllTagsCreative (id) {
    return Vue.http.get(`api_v2/adtag/creative/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getSingleTag (id) {
    return Vue.http.get(`api_v2/adtag/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  deleteSingleTag (id) {
    return Vue.http.delete(`api_v2/adtag/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  refreshSingleTag (id) {
    return Vue.http.get(`api_v2/adtag/${id}/refresh`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  updateSingleTag (data) {
    return Vue.http.put(`api_v2/adtag/${data.id}`, data).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  /* #####################################################################
  *
  *      Downloads
  *
  * #####################################################################
  */
  getUserDownloads () {
    return Vue.http.get(`api_v2/downloads/user/list`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getCreativeDownloads (id) {
    return Vue.http.get(`api_v2/downloads/creative/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  getDownload (id) {
    return Vue.http.get(`api_v2/downloads/${id}`).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  },
  createSignedDownloadRequest (payload) {
    return Vue.http.post('api_v2/download/request', payload).then(response => {
      return response.data
    }, error => {
      throw errorText(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/api.js